import { Icon, disableCache } from "@iconify/react";
import styled from "styled-components";

import type { IconProps } from "@iconify/react";

interface Props extends IconProps {
  readonly size?: IconProps["width"];
}
export default function Iconify({ icon, size = "1em", className = "", ...other }: Readonly<Props>) {
  return (
    <StyledIconify className="anticon">
			<Icon icon={icon} width={size} height={size} className={`m-auto ${className}`} {...other} />
		</StyledIconify>);

}

disableCache("local");
const StyledIconify = styled.div`
  display: inline-flex;
  vertical-align: middle;
  svg {
    display: inline-block;
  }
`;